<template>

<div class="section-container">

  <div id="slide03" class="section">

    <Subtitle :text="$t('home.slide03.title')"/>

    <div class="chart-block">

      <Fimage name="circle01.png"/>

      <Fimage name="circle02.png"/>

      <Fimage name="circle03.png"/>

    </div>

    <Arrow
      type="down"
      toType="page"
      toId="#slide04"
      :text="$t('home.slide03.arrow')"/>

  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import Fimage from '../general/elements/Fimage.vue'
import Arrow from '../general/elements/Arrow.vue'

export default {
  name: 'Slide03',
  components: {
    Subtitle,
    Fimage,
    Arrow
  }
}
</script>

<style lang="scss" scoped>
.section {
  .chart-block {
    text-align: center;
    margin: auto;

    img {
      width: 35%;
      margin: 0 -2%;
    }
  }
}

@media (max-width: 850px), (max-device-width: 850px) {
  .section {
    .chart-block {
      img {
        width: 50%;
        margin: -5% -1%;
      }
    }
  }
}

@media (max-width: 550px), (max-device-width: 550px) {
  .section {
    .chart-block {
      img {
        width: 80%;
        margin: -5% 0;
      }
    }
  }
}
</style>
